import styled from 'styled-components';
import { s } from './NPL.styles';
import { NumberwithComma, ReportFormatNumber } from '../../../../func/Function';
import { NplCalculation } from '../../../../utils/nplAnalysis';

interface ISaleDateSimulationProps {
  bidDateSimulation: ReturnType<NplCalculation['getBidDateSimul']>;
}

const SaleDateSimulation = (props: ISaleDateSimulationProps) => {
  const { bidDateSimulation } = props;
  return (
    <s.Div>
      <s.Title>매각기일 시뮬레이션</s.Title>
      <div>
        <SlideWrapper>
          {bidDateSimulation.map((item, index) => (
            <SlideDiv key={index}>
              <Degree>{index + 1}차 매각기일</Degree>
              <Row>
                <s.LeftCell>일자</s.LeftCell>
                <s.RightCell>
                  {item.date.split(' ')[0].replaceAll('-', '.')}
                </s.RightCell>
              </Row>
              <Row>
                <s.LeftCell>일수차</s.LeftCell>
                <s.RightCell>{item.days}</s.RightCell>
              </Row>
              <Row>
                <s.LeftCell>평가금액</s.LeftCell>
                <s.RightCell>{ReportFormatNumber(item.price)}</s.RightCell>
              </Row>
              <Row>
                <s.LeftCell>저감률</s.LeftCell>
                <s.RightCell>
                  {ReportFormatNumber(item.rate, true, true)}
                </s.RightCell>
              </Row>
            </SlideDiv>
          ))}
        </SlideWrapper>
        <s.BlueSmallText>
          *이미 경매가 진행 중인 경우에는 해당 경매일정을 반영함
        </s.BlueSmallText>
      </div>
    </s.Div>
  );
};

export default SaleDateSimulation;

const SlideWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  overflow-x: auto;
  /* 스크롤바 숨기기 */
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const SlideDiv = styled.div`
  width: 260px;
  height: 176px;
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 14px 16px;
  background-color: #f7f8fc;
  border-radius: 8px;
  border: 1px solid rgba(112, 115, 124, 0.16);
`;

const Degree = styled.div`
  color: #222222;
  font-size: 14px;
  font-weight: 500;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;
